import * as React from 'react';
import { cn } from 'lib/utils';

export interface PanelProps {
  title: React.ReactNode;
  /** The header's right side: a count, a badge or a link. */
  aside?: React.ReactNode;
  /** Drop the body padding for lists and tables that pad their own rows. */
  flush?: boolean;
  /** The title's heading level; pages whose own title is an h1 keep the default. */
  headingLevel?: 'h2' | 'h3';
  className?: string;
  bodyClassName?: string;
  children: React.ReactNode;
}

/** A bordered section with a 48px header (title left, aside right) over its body. */
export function Panel({
  title,
  aside,
  flush = false,
  headingLevel: Heading = 'h2',
  className,
  bodyClassName,
  children,
}: PanelProps) {
  return (
    <section className={cn('flex min-w-0 flex-col overflow-hidden rounded-lg border border-border bg-card', className)}>
      <div className="flex h-12 shrink-0 items-center justify-between gap-3 border-b border-border px-4">
        <Heading className="truncate text-sm font-semibold text-foreground">{title}</Heading>
        {aside != null && <div className="flex shrink-0 items-center gap-2 text-[13px] text-muted-foreground">{aside}</div>}
      </div>
      <div className={cn(!flush && 'p-4', bodyClassName)}>{children}</div>
    </section>
  );
}

export default Panel;
